import InfoPanel from '@/components/common/InfoPanel/InfoPanel'
import InfoItem from '@/components/common/InfoItem/InfoItem'

export default function SalesInformation({storeData}) {
  return (
    <InfoPanel title="Sales Information" isCollapsible={true} defaultOpen={true} className="mt-4 ">
      <div className="px-4">
        <div className="grid grid-cols-3 gap-y-6">
          <InfoItem label="Sales Office Code" value={storeData?.salesInformation?.salesOfficeCode ?? '-'} />
          <InfoItem label="Sales Office Name" value={storeData?.salesInformation?.salesOfficeName ?? '-'} />
          <InfoItem label="Sales Channel Code" value={storeData?.salesInformation?.salesChannelCode ?? '-'} />

          <InfoItem label="Sales Organization" value={storeData?.salesInformation?.salesOrganization ?? '-'} />
          <InfoItem 
            label="Sales Block Status" 
            value={
              storeData?.salesInformation?.salesBlockStatus === "-1"
                ? 'No' 
                : storeData?.salesInformation?.salesBlockStatus === "1" 
                ? 'Yes' 
                : '-'
            } 
          />
          <InfoItem label="Sales Volume Classification Value" value={storeData?.salesInformation?.salesVolumeClassificationValue ?? '-'} />

          <InfoItem label="Relationship Type Code" value={storeData?.salesInformation?.relationshipTypeCode ?? '-'} />
          <InfoItem label="Business Type" value={storeData?.salesInformation?.businessType ?? '-'} />
          <InfoItem label="Business Segmentation Node Code" value={storeData?.salesInformation?.businessSegmentationNodeCode ?? '-'} />

          <InfoItem label="Business Model Code" value={storeData?.salesInformation?.businessModelCode ?? '-'} />
          <InfoItem label="Classification Code" value={storeData?.salesInformation?.classificationCode ?? '-'} />
          <InfoItem label="Classification Type Code" value={storeData?.salesInformation?.classificationTypeCode ?? '-'} />

          <InfoItem label="MOA" value={storeData?.salesInformation?.moa ?? '-'} />
          <InfoItem label="GTMU" value={storeData?.salesInformation?.gtmu ?? '-'} />
          <InfoItem label="Division" value={storeData?.salesInformation?.division ?? '-'} />
        </div>
      </div>
    </InfoPanel>
  )
}
